// src/pages/guide/GuideComingSoon.tsx

import React from "react";

import {
  Link,
  useParams,
} from "react-router-dom";

import "./GuideComingSoon.css";


// =====================================================
// GAME INFORMATION
// =====================================================

const GAME_NAMES: Record<string, string> = {
  tika: "Tika",
  bitruno: "Bitruno",
  charwali: "Charwali",
  fiskoot: "Fiskoot",
};


// =====================================================
// GUIDE COMING SOON
// =====================================================

const GuideComingSoon: React.FC = () => {

  const {
    gameName,
  } = useParams<{
    gameName: string;
  }>();


  const game =
    GAME_NAMES[
      gameName?.toLowerCase() || ""
    ] || "This Game";


  return (
    <main className="guide-coming-page">

      {/* =========================================== */}
      {/* BACKGROUND DECORATION                       */}
      {/* =========================================== */}

      <div
        className="guide-coming-glow guide-coming-glow-one"
        aria-hidden="true"
      />

      <div
        className="guide-coming-glow guide-coming-glow-two"
        aria-hidden="true"
      />


      {/* =========================================== */}
      {/* CONTENT                                     */}
      {/* =========================================== */}

      <section className="guide-coming-card">

        {/* ========================================= */}
        {/* P-ARENA BRAND                             */}
        {/* ========================================= */}

        <div className="guide-coming-brand">
          P-ARENA
        </div>


        {/* ========================================= */}
        {/* CARD SUITS                                */}
        {/* ========================================= */}

        <div
          className="guide-coming-suits"
          aria-hidden="true"
        >
          <span>♠</span>
          <span className="red-suit">♥</span>
          <span className="red-suit">♦</span>
          <span>♣</span>
        </div>


        {/* ========================================= */}
        {/* STATUS                                    */}
        {/* ========================================= */}

        <div className="guide-coming-status">
          GAME GUIDE
        </div>


        {/* ========================================= */}
        {/* TITLE                                     */}
        {/* ========================================= */}

        <h1>
          {game} Guide
        </h1>


        <div className="guide-coming-divider">
          <span />
          <i>♣</i>
          <span />
        </div>


        {/* ========================================= */}
        {/* MESSAGE                                   */}
        {/* ========================================= */}

        <h2>
          Guide Coming Soon
        </h2>

        <p>
          The official {game} game guide is not
          available yet.
        </p>

        <p className="guide-coming-secondary">
          We're preparing the complete rules,
          scoring system, examples, and gameplay
          instructions for P-ARENA.
        </p>


        {/* ========================================= */}
        {/* ACTIONS                                   */}
        {/* ========================================= */}

        <div className="guide-coming-actions">

          <Link
            to="/"
            className="guide-coming-primary"
          >
            Back to Game House
          </Link>

          <Link
            to="/guides/fasoor"
            className="guide-coming-secondary-button"
          >
            View Fasoor Guide
          </Link>

        </div>


        {/* ========================================= */}
        {/* FOOTER                                    */}
        {/* ========================================= */}

        <div className="guide-coming-footer">
          PLAY • CONNECT • COMPETE
        </div>

      </section>

    </main>
  );
};


export default GuideComingSoon;